var _RangeEnumerator_start, _RangeEnumerator_count, _RangeEnumerator_increment, _RangeEnumerator_current, _RangeEnumerator_iterations;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import EnumeratorBase from "./EnumeratorBase";
import ArgumentException from '../Exceptions/ArgumentException';
import Exception from '../Exceptions/Exception';
export default class RangeEnumerator extends EnumeratorBase {
    constructor(start, count) {
        super();
        _RangeEnumerator_start.set(this, void 0);
        _RangeEnumerator_count.set(this, void 0);
        _RangeEnumerator_increment.set(this, void 0);
        _RangeEnumerator_current.set(this, void 0);
        _RangeEnumerator_iterations.set(this, void 0);
        const integer = start > 0 ? Math.floor(start) : Math.ceil(start);
        if (start != integer) {
            throw new ArgumentException("Only integers are supported");
        }
        __classPrivateFieldSet(this, _RangeEnumerator_start, start, "f");
        __classPrivateFieldSet(this, _RangeEnumerator_count, count, "f");
        __classPrivateFieldSet(this, _RangeEnumerator_iterations, -1, "f");
        __classPrivateFieldSet(this, _RangeEnumerator_increment, 1, "f");
    }
    get current() {
        if (__classPrivateFieldGet(this, _RangeEnumerator_iterations, "f") < 0) {
            throw new Exception("Call moveNext first");
        }
        if (__classPrivateFieldGet(this, _RangeEnumerator_current, "f") === undefined) {
            throw new Exception("Current is undefined");
        }
        return __classPrivateFieldGet(this, _RangeEnumerator_current, "f");
    }
    moveNext() {
        var _a;
        __classPrivateFieldSet(this, _RangeEnumerator_current, this.peek(), "f");
        if (__classPrivateFieldGet(this, _RangeEnumerator_current, "f") === undefined) {
            return false;
        }
        __classPrivateFieldSet(this, _RangeEnumerator_iterations, (_a = __classPrivateFieldGet(this, _RangeEnumerator_iterations, "f"), _a++, _a), "f");
        return true;
    }
    peek() {
        const index = __classPrivateFieldGet(this, _RangeEnumerator_iterations, "f") + 1;
        const value = __classPrivateFieldGet(this, _RangeEnumerator_start, "f") + (index * __classPrivateFieldGet(this, _RangeEnumerator_increment, "f"));
        if (index < __classPrivateFieldGet(this, _RangeEnumerator_count, "f")) {
            return value;
        }
    }
    reset() {
        __classPrivateFieldSet(this, _RangeEnumerator_iterations, -1, "f");
    }
}
_RangeEnumerator_start = new WeakMap(), _RangeEnumerator_count = new WeakMap(), _RangeEnumerator_increment = new WeakMap(), _RangeEnumerator_current = new WeakMap(), _RangeEnumerator_iterations = new WeakMap();
